module.exports = __webpack_public_path__ + "static/media/clap-bw.bf6ba63e.svg";